import moment from 'moment';

export const parseTrainData = (trainDetails, passengerDetails) => {
	const tDetails = {};
	const pDetail = [];

	for (let key in trainDetails) {
		let val = trainDetails[key];
		if (key !== 'trainNo' && key !== 'trainName' && !val) {
			return false;
		}
		if (key === 'travelDate' && val) {
			tDetails[key] = moment(val).valueOf();
		} else if (key === 'classType') {
			tDetails['class'] = val.value;
		} else {
			tDetails[key] = (val && val.value) ? val.value : val;
		}
	}

	if (passengerDetails && passengerDetails.length > 0) {
		for (let passenger of passengerDetails) {
			const pass = {};
			for (let key in passenger) {
				let val = passenger[key];
				pass[key] = (val && val.name) ? val.name : val;
			}
			pDetail.push(pass);
		}
	} else {
		return false;
	}
	const apiRequest = {
		trainDetails: tDetails,
		passengerDetails: pDetail
	};
	return apiRequest;
};

export const validateId = (validation, value) => {
	const isValid = validation.validator(value);
	if (typeof isValid === 'string' && isValid.length > 4 && !validation.msg) {
		return isValid;
	}
	return (!isValid ? validation.msg : false);
};
